import { useState } from 'react';
import { Grid, Button, MenuItem, Select, FormControl, DialogActions, DialogContent } from '@mui/material';
import { DialogCustom, DialogTitleCustom, FieldWrap } from '@tap/mui-ui';
import { ICancelDialogResult, IDialogProps } from '@tap/tap-ui';
import { issueService } from '@tap/data-providers';
import { CommentEditor, useComment } from '@tap/doc-ui';
import { LoadingButton } from '@mui/lab';

/*
*   Диалог: Удалить заявку
*/


type IDeleteIssueDialogProps = IDialogProps<{ issueKeys: string[] }, ICancelDialogResult>;

const reasonConst = [
    { label: 'Заявка отменена', id: 1 },
    { label: 'Заявка больше не актуальна', id: 2 },
    { label: 'Другое', id: 3 },
];


export default function DeleteIssueDialog({
    data,
    isOpen,
    handleClose,
}: IDeleteIssueDialogProps) {

    const [reason, setReason] = useState<any>(reasonConst[0].id);
    const [isLoading, setIsLoading] = useState(false);

    const commentState = useComment({ documentKeys: data.issueKeys, actionCode: 'issue__delete' });

    const handleCancel = () => {
        handleClose({ isCancel: true });
    }

    const handleMainAction = () => {
        setIsLoading(true);
        return issueService.deleteIssueByKey(data.issueKeys[0])
            .then(() => {
                commentState.addComment();
            })
            .then(() => {
                setIsLoading(false);
                handleClose({ isCancel: false });
            });
    }


    return (
        <DialogCustom
            handleClose={handleCancel}
            open={isOpen}
        >
            <DialogTitleCustom
                primaryText={'Удалить заявку'}
            />
            <DialogContent>
                <Grid
                    item
                    container
                    spacing={2}
                    alignItems='stretch'
                >

                    <FieldWrap label={'Причина'}>
                        <Select
                            autoFocus
                            value={reason}
                            size='small'
                            onChange={e => setReason(e.target.value)}
                            sx={{
                                maxWidth: '300px',
                                width: '100%',
                            }}
                        >
                            {reasonConst.map((r: any) => <MenuItem key={r.id} value={r.id}>{r.label}</MenuItem>)}
                        </Select>
                    </FieldWrap>

                    <FieldWrap label={'Комментарий'}>
                        <FormControl sx={{ width: '100%' }}>
                            <CommentEditor {...commentState} />
                        </FormControl>
                    </FieldWrap>

                </Grid>
            </DialogContent>
            <DialogActions >
                <Grid container justifyContent='flex-end'>

                    <LoadingButton
                        disableElevation
                        type='button'
                        variant='contained'
                        color='primary'
                        onClick={handleMainAction}
                        sx={{ mr: 2 }}
                        loading={isLoading}
                    >
                        Удалить
                    </LoadingButton>

                    <Button
                        disableElevation
                        type='button'
                        variant='text'
                        color='primary'
                        onClick={handleCancel}
                    >
                        Отмена
                    </Button>

                </Grid>
            </DialogActions>
        </DialogCustom >
    );
}
